<template>
    <div class="avatar-box m-2 d-flex justify-content-center">
        <div :id="avatar.id">
            <img
                :src="`https://assets.beereaders.com/avatar/${avatar.name}/${avatar.value}`"
                class="transition-all"
                alt="Avatar"
                height="120"
                width="120"
            />
        </div>
    </div>
</template>

<script>
import { DEFAULT_AVATAR } from "@/constants/DefaultConstants"

export default {
    props: {
        avatar: {
            type: Object,
            default: DEFAULT_AVATAR,
        },
        progress: Number
    },
    data() {
        return {
            gradient: {
                radial: false,
                colors: [
                    {
                        color: '#FFDA00',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#FFC400',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            }
        }
    }
}
</script>

<style lang="css" scoped>

.avatar-box {
    position: fixed;
    top: -2%;
}
@media (min-height: 700px) {
    .avatar-box {
        top: 0%;
    }
}
@media (min-height: 750px) {
    .avatar-box {
        top: 2%;
    }
}
@media (min-height: 760px) {
    .avatar-box {
        top: -2%;
    }
}
@media (min-height: 800px) {
    .avatar-box {
        top: 0%;
    }
}
@media (min-height: 850px) {
    .avatar-box {
        top: 3%;
    }
}
@media (min-height: 900px) {
    .avatar-box {
        top: 5%;
    }
}
@media (min-height: 950px) {
    .avatar-box {
        top: 8%;
    }
}
@media (min-height: 1000px) {
    .avatar-box {
        top: 10%;
    }
}
@media (min-height: 1050px) {
    .avatar-box {
        top: 12%;
    }
}
@media (min-height: 1100px) {
    .avatar-box {
        top: 14%;
    }
}
@media (min-height: 1150px) {
    .avatar-box {
        top: 16%;
    }
}
@media (min-height: 1200px) {
    .avatar-box {
        top: 18%;
    }
}
@media (min-height: 1250px) {
    .avatar-box {
        top: 20%;
    }
}
@media (min-height: 1300px) {
    .avatar-box {
        top: 22%;
    }
}
@media (min-height: 1350px) {
    .avatar-box {
        top: 24%;
    }
}
@media (min-height: 1400px) {
    .avatar-box {
        top: 26%;
    }
}
@media (min-height: 1450px) {
    .avatar-box {
        top: 28%;
    }
}
@media (min-height: 1500px) {
    .avatar-box {
        top: 30%;
    }
}

.avatar-box img,
.avatar-image img {
    border-radius: 100%;
}
</style>
